import config from './config'
import GA from 'react-ga4'
import * as maps from './maps'
import * as api from './api'

GA.initialize('G-WJP85E58K8')

GA.event({
  category: 'web_sdk',
  action: 'web_sdk_loaded',
})

export default {
  maps: maps.default,
  api: api.default,

  get apiKey(): string | null {
    return config.API_KEY
  },

  set apiKey(token: string | null) {
    config.API_KEY = token
  },

  setApiKey(token: string | null) {
    config.API_KEY = token
  },

  get apiHost(): string | null {
    return config.API_HOST
  },

  set apiHost(host: string | null) {
    config.API_HOST = host
  },

  setApiHost(host: string | null) {
    config.API_HOST = host
  },
}
